import React, { useState, useEffect } from 'react';
import BasicCard from '../../../components/basics/cards/BasicCard';
import FilterSettings from '../../../components/FilterSettings'

import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Button from 'react-bootstrap/Button'
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import { TokenService } from '../../../services/TokenService';
import MitigationList from './MitigationList';

function Mitigations() {
    const [updatingFilter, setUpdatingFilter] = useState(false)
    const [filterArray, setFilterArray] = useState(0)

    const [pageConfig, setPageConfig] = useState({
        controllerName: "Mitigations",
        apiName: process.env.REACT_APP_LST_API_DOMAIN + '/api/',
        parameters: "",
    })
    useEffect(() => {
        CommonAPIService.callApiUsingUrl(`${pageConfig.apiName}${pageConfig.controllerName}/PageSettings`)
            .then(data => setPageConfig({ ...pageConfig, ...{ pageSettings: data } }))
            .catch(error => console.error(error));
    }, [pageConfig.apiName, pageConfig.controllerName]);

    
    const downloadMitigations = () => {
        const user = TokenService.getUser();
        const userEmail = user.account.username;
        const { apiName, controllerName, pageSettings } = pageConfig
        const filterArrayString = encodeURIComponent(JSON.stringify(filterArray));

        CommonAPIService.callApiUsingUrlReturnBlob(`${apiName}${controllerName}/Download?filterArray=${filterArrayString}`)
            .then(blob => {
                // Create a URL for the blob
                const url = URL.createObjectURL(blob);

                // Create a link element and set its href attribute to the blob URL
                const link = document.createElement('a');
                link.href = url;

                // Set the link element's download attribute to the desired file name
                link.download = "MitigationTemplate.xlsx";

                // Click the link to download the file
                link.click();

                // Clean up the URL and link elements
                URL.revokeObjectURL(url);
                link.remove();
            }, [apiName], [controllerName], [filterArray])
            .catch(error => console.error(error));
    }


    return (
        <BasicCard cardConfig={{ cardTitle: 'Mitigations', cardHeadingElement: 'h4' }}>
            <Tabs defaultActiveKey='download' id='mitigations-tabs' className='mb-3'>
                <Tab eventKey='download' title='Edit and Download mitigations'>
                    <BasicCard cardConfig={{ cardTitle: '', cardHeadingElement: 'h4' }}>
                        <FilterSettings pageConfig={pageConfig} filterArray={filterArray} setFilterArray={setFilterArray} updatingFilter={updatingFilter} /> 
                        <MitigationList pageConfig={pageConfig} filterArray={filterArray} />
                        <BasicCard cardConfig={{ cardTitle: 'Download', cardHeadingElement: 'h5' }}>
                            <span className='brd-download-items'>
                                <Button variant='primary' onClick={downloadMitigations}>
                                    Download
                                </Button>
                            </span>
                        </BasicCard>
                    </BasicCard>
                </Tab>
            </Tabs>
        </BasicCard>
    );
}

export default Mitigations;